const DO_NOT_SHOW_IN_MENU = 'doNotShowInMenu'

export default {
  DO_NOT_SHOW_IN_MENU
}
